import { useState, useCallback } from 'react';
import { useStateContext } from '../../../../../../contexts/ContextProvider';
import { message } from 'antd';


export const useFurnizorPage = () => {
  const { token } = useStateContext();
  const [furnizorProducts, setFurnizorProducts] = useState([]);
  const [ furnizorData, setFurnizorData] = useState([]);
  const [productRequestStatuses, setProductRequestStatuses] = useState([]);
  const [purchaseRequestsStatuses, setPurchaseRequestsStatuses] = useState([]);
  const [loading, setLoading] = useState(false);


  const getProductRequestStatuses = useCallback(async () => {
    if (!token) {
      console.warn('⚠️ getProductRequestStatuses: No token available');
      return;
    }

    console.log('🔄 getProductRequestStatuses: Starting fetch...');

    try {
      const url = `${process.env.REACT_APP_API_URL}/get_products_in_purchase_statuses?token=${token}`;
      console.log('🏷️ getProductRequestStatuses: Making request to:', url);

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        console.log('✅ getProductRequestStatuses: Data received:', data.length, 'items');
        setProductRequestStatuses(data);
      } else {
        console.error('❌ getProductRequestStatuses: HTTP error:', response.status, response.statusText);
        message.error('Eroare la încărcarea statusurilor');
      }
    } catch (error) {
      console.error('❌ getProductRequestStatuses: Network error:', error);
      message.error('Eroare de conexiune');
    }
  }, [token]);


  const getFurnizorData = useCallback(async ({furnizor_id}) => {
    if (!token) return;

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/furnizori/${furnizor_id}?token=${token}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setFurnizorData(data);
      } else {
        message.error('Eroare la încărcarea datelor furnizorului');
        return [];
      }
    } catch (error) {   
      console.error('Eroare la încărcarea datelor furnizorului:', error);
      message.error('Eroare de conexiune');
      return [];
    }
  }, [token]);


  const getFurnizorProducts = useCallback(async ({furnizor_id}) => {
    if (!token) return;

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/get_products_in_purchase_requests_by_furnizor?product_in_purchase_statuses=1,2,3,4,5,6,7&furnizor_id=${furnizor_id}&token=${token}`, {
        method: 'GET',
        headers: {  
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setFurnizorProducts(data);
      } else {
        message.error('Eroare la încărcarea produselor în cereri');
        return [];
      }
    } catch (error) {
      console.error('Eroare la încărcarea produselor în cereri:', error);
      message.error('Eroare de conexiune');
      return [];
    }
  }, [token]);



  const changeProductRequestStatus = useCallback(async ({pr_id, pr_status_id}) => {
    if (!token) return;

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/change_product_request_status?pr_id=${pr_id}&pr_status_id=${pr_status_id}&token=${token}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });

      if (response.ok) {
        message.success('Starea cererii a fost schimbată cu succes');
      } else {
        message.error('Eroare la schimbarea stării cererii');
      }
    } catch (error) {
      console.error('Eroare la schimbarea stării cererii:', error);
      message.error('Eroare de conexiune');
      return [];
    }
  }, [token]);



  const getPurchaseRequestsStatuses = useCallback(async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/get_purchase_request_statuses?token=${token}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (response.ok) {
      const data = await response.json();
      setPurchaseRequestsStatuses(data);
    }
  }, [token]);

  return {
    furnizorProducts,
    furnizorData,
    loading,
    productRequestStatuses,
    purchaseRequestsStatuses,
    getFurnizorProducts,
    getFurnizorData,
    getProductRequestStatuses,
    getPurchaseRequestsStatuses,
    changeProductRequestStatus
  };
}; 